import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";

export const useDatasetMappedValue = (
	mapValue: number | undefined,
	mapperId: number
) => {
  const { data } = useGetDatasetMapperData(mapperId ?? null)
	if (!mapValue || !data) return null;
	return data?.mappings[mapValue];
};